export default __webpack_public_path__ + "98c5286ac634afef0c264c3db8c862d0.jpg";